import { SvgIcon } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapCTA } from '@websrc/DataMappers/mapCTA'
import { mapVideoAsset } from '@websrc/DataMappers/mapVideoAsset'
import clsx from 'clsx'
import { hoverShadow, styles } from 'leds'
import React, { FC, useContext } from 'react'

import { Asset } from '../Asset/Asset'
import { CTA } from '../CTA'
import { card } from './CTACard.css'

export interface CTACardProps {
  cta: ReturnType<typeof mapCTA>
  asset: ReturnType<typeof mapVideoAsset>
}

export const CTACard: FC<CTACardProps> = ({ cta, asset }) => {
  const { matomoPageTemplate } = useContext(AppProviderContext)

  return (
    <div className={clsx(card._, hoverShadow)}>
      <div className={card.contentWrapper}>
        <div className={card.imageWrapper}>
          <Asset
            className={styles({ width: 'full' })}
            objectFit={'cover'}
            thumbnail={asset.thumbnail}
          />
        </div>
        <CTA
          className={card.cta}
          cta={cta}
          fontWeight={'bold'}
          onClick={() => {
            matomo.trackEvent(
              'engagement',
              matomoPageTemplate,
              ['cta card list'],
              [cta?.text],
              'card'
            )
          }}
          prefix={<SvgIcon color={'white'} name={'ARROW_RIGHT'} size={20} />}
        />
        <div className={card.gradient} />
      </div>
    </div>
  )
}
